var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kst-section',{attrs:{"collapsible":"","collapsed":"","info-mode":"","help-collapsed":_vm.sectionHelp,"title":_vm.sectionTitle}},[_c('kst-output',{attrs:{"field":"Name","data":_vm.data,"catalog":_vm.Catalog}}),_c('kst-output',{attrs:{"field":"Address","data":_vm.data,"catalog":_vm.ClientAddressCatalog}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }